import { BigNumber } from "@ethersproject/bignumber"
import { Token } from "../constants"
import { Erc20 } from "../../types/ethers-contracts/Erc20"
import { LpTokenUnguarded } from "../../types/ethers-contracts/LpTokenUnguarded"
import { MaxUint256 } from "@ethersproject/constants"
import { useTransactionModal } from "src/providers/TransactionModalProvider"
import { useCallback } from "react"

/**
 * Checks if a spender is allowed to spend some amount of a token.
 * Approves them to spend if they're not already allowed.
 * Won't make requests if spendingValue eq 0
 * @param {Contract} srcTokenContract
 * @param {string} spenderAddress
 * @param {string} ownerAddress
 * @param {BigNumber} spendingValue
 * @param {boolean} infiniteApproval
 * @param {{}} callbacks
 * @return {Promise<void>}
 */

export const useCheckAndApproveTokenForTrade = () => {
  const { addTransactions } = useTransactionModal()

  return useCallback(
    async (
      srcTokenContract: Erc20 | LpTokenUnguarded,
      spenderAddress: string,
      ownerAddress: string,
      spendingValue: BigNumber, // max is MaxUint256
      infiniteApproval = true,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      gasPrice: BigNumber, // @dev unused
      callbacks: {
        onTransactionError?: (error: Error | string) => () => void
      } = {},
      token: Token,
    ) => {
      if (srcTokenContract == null) return
      if (spendingValue.eq(0)) return
      const tokenName = await srcTokenContract.symbol()
      const existingAllowance = await srcTokenContract.allowance(
        ownerAddress,
        spenderAddress,
      )

      console.debug(
        `Existing ${tokenName} Allowance: ${existingAllowance.toString()}`,
      )
      if (existingAllowance.gte(spendingValue)) return
      async function approve(amount: BigNumber): Promise<void> {
        try {
          const transaction = async () =>
            await srcTokenContract.approve(spenderAddress, amount)

          const summary = [
            {
              label: "Approve",
              amount: "",
              token,
            },
          ]
          await addTransactions([transaction], summary)

          // await enqueuePromiseToast(
          //   chainId || ChainId.MAINNET,
          //   confirmedTransaction,
          //   "tokenApproval",
          //   {
          //     tokenName,
          //   },
          // )
        } catch (error) {
          callbacks.onTransactionError?.(error as Error)
          throw error
        }
      }
      // if (existingAllowance.gt("0")) {
      //   // Reset to 0 before updating approval
      //   await approve(Zero)
      // }
      await approve(infiniteApproval ? MaxUint256 : spendingValue)
      console.debug(
        `Approving ${tokenName} spend of ${spendingValue.toString()}`,
      )
    },
    [addTransactions],
  )
}
